import * as React from "react";
import { forwardRef } from "react";
const SvgSouthEast = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M14.625 7.125H13.125V12.0675L4.4325 3.375L3.375 4.4325L12.0675 13.125H7.125V14.625H14.625V7.125Z", fill: "#F7F8FA" }));
const ForwardRef = forwardRef(SvgSouthEast);
export { ForwardRef as ReactComponent };
